import { LanguageType } from '@/models/LanguageType';
import React from 'react';
import NewArticle from '../NewArticle';
import NewAudio from '../NewAudio';
import NewLink from '../NewLink';
import NewVideo from '../NewVideo';

interface NewItemProps {
    type: string | null;
    language: LanguageType;
    handleOnCancel: () => void;
}

const NewItem = ({ type, language, handleOnCancel }: NewItemProps) => (
    <>
        {type === 'article' && <NewArticle handleOnCancel={handleOnCancel} language={language} />}
        {type === 'link' && <NewLink handleOnCancel={handleOnCancel} language={language} />}
        {type === 'video' && <NewVideo handleOnCancel={handleOnCancel} language={language} />}
        {type === 'audio' && <NewAudio handleOnCancel={handleOnCancel} language={language} />}
    </>
);

export default NewItem;
